document.addEventListener('DOMContentLoaded',
  function () {
    requirejs(['common/components/searchWrapper'],
      function (searchWrapper) {
        searchWrapper('.search-wrapper form', false)

        const searchFormElement = document.querySelector('.search-wrapper form')

        var neighborhoodId = document.getElementById('neighborhoodId')
        var cityId = document.getElementById('cityId')
        var stateId = document.getElementById('stateId')
        var activeSearchId = document.getElementById('activeSearchId')
        var typeOfAd = document.getElementById('TypeOfAd')
        var adRealStateType = document.getElementById('AdRealStateType')
        var buscaHome = document.getElementById('busca-home')

        let formFieldsForUrl = [
          typeOfAd,
          adRealStateType,
          buscaHome,
          stateId,
          cityId,
          neighborhoodId,
          activeSearchId
        ]

        function pretyRouteUrl(url) {
          url += '/'
          formFieldsForUrl.forEach(function (field) {
            url += field.id !== 'busca-home'
              ? field.value + '/'
              : field.value.replace(/[^\w]+|\w{2}$/g, ' ').trim().replace(/\s+/g, '-').toLowerCase() + '/'
          })

          return url.replace(/\b\w/g, function (l) { return l.toUpperCase() })
        }

        function logBuscaGA4 () {
          //log no google analytics
          window.dataLayer = window.dataLayer || []
          dataLayer.push({
            'event': 'NeighborhoodSearch',
            'neighborhoodId': `id-${neighborhoodId.value}`,
            'name': `${buscaHome.value}`,
            'cityId': `${cityId.value}`,
            'stateId': `${stateId.value}`,
            'activeSearchId': `${activeSearchId.value}`
          })
        }

        function submitEvent(e) {
          searchFormElement.removeEventListener('citySelected', submitEvent)
          neighborhoodId.value = e.detail.neighborhoodId
          cityId.value = e.detail.cityId
          stateId.value = e.detail.stateId
          activeSearchId.value = e.detail.id
          typeOfAd.removeAttribute('name')
          adRealStateType.removeAttribute('name')
          logBuscaGA4()
          searchFormElement.action = pretyRouteUrl(searchFormElement.action)
          searchFormElement.submit()
        }

        searchFormElement.addEventListener('citySelected', submitEvent)

        // #region Layout rotativo Portal Creci Brasil
        var layoutId = getRandom(1, 6)

        document.body.classList.add('layout-0' + layoutId)

        function getRandom(min, max) {
          min = Math.ceil(min)
          max = Math.floor(max)
          return Math.floor(Math.random() * (max - min + 1)) + min
        }
        // #endregion
      })
  })
